import React from 'react';
import { ShieldCheck, Scale, TrendingUp, AlertCircle, Gavel, Package } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { benefits } from '../mock';

const iconMap = [ShieldCheck, Scale, TrendingUp, AlertCircle, Gavel, Package];

export const BenefitsSection = () => {
  return (
    <section id="benefits" className="py-20 bg-[#EFEBE9]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#3E2723] mb-4">
            Benefits of Trademark Registration
          </h2>
          <p className="text-lg text-[#8D6E63] max-w-3xl mx-auto">
            Registering your trademark with the USPTO provides powerful legal protections and business advantages that can significantly impact your brand's success.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[index];
            return (
              <Card
                key={index}
                className="border-2 border-[#D7CCC8] hover:border-[#8D6E63] transition-all duration-300 hover:shadow-xl bg-white"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-[#3E2723] rounded-lg flex items-center justify-center mb-4">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <CardTitle className="text-xl font-bold text-[#3E2723]">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-[#8D6E63] leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-12 bg-white border-2 border-[#D7CCC8] rounded-lg p-8">
          <h3 className="text-2xl font-bold text-[#3E2723] mb-4 text-center">
            Don't Wait Until It's Too Late
          </h3>
          <p className="text-[#8D6E63] text-center leading-relaxed max-w-3xl mx-auto">
            Trademark rights are based on first use and first to file. Delaying your trademark registration could allow competitors to claim similar marks, potentially forcing costly rebranding efforts. Protect your brand today with professional trademark registration services.
          </p>
        </div>
      </div>
    </section>
  );
};
